import { render, staticRenderFns } from "./createcollectormodel.vue?vue&type=template&id=5b3d9561&"
import script from "./createcollectormodel.vue?vue&type=script&lang=ts&"
export * from "./createcollectormodel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "createcollectormodel.vue"
export default component.exports